<template>
  <div>
    <MobilePayRedirect :countdownText="mobilePayRedirectText" />
    <nav class="page-nav">
      <doLink
        v-if="getStep < 1 || getStep > steps.length - 2"
        :value="this.$store.state.pageData.Stepper"
      />
      <button
        v-if="getStep > 0 && getStep < steps.length - 1"
        class="btn btn-white btn-lg"
        @click="goBack()"
      >
        {{ this.$store.state.pageData.Stepper.buttonBackward }}
      </button>
      <button
        class="btn btn-primary btn-lg"
        v-if="getStep < steps.length - 2"
        @click="goNext()"
      >
        {{ this.$store.state.pageData.Stepper.buttonForward }}
      </button>
      <button
        v-if="
          getStep === steps.length - 2 &&
          this.newData[getStep].Questions[0].Value
        "
        class="btn btn-primary btn-lg"
        @click="postData()"
      >
        {{ this.$store.state.pageData.Stepper.buttonSignUp }}
      </button>
      <button
        v-b-modal="`modal-${this.page.SID}`"
        :for="'check' + this.page.SID"
        v-if="
          getStep === steps.length - 2 &&
          !this.newData[getStep].Questions[0].Value
        "
        class="btn btn-primary btn-lg"
        @click="openModal()"
      >
        {{ this.$store.state.pageData.Stepper.buttonSignUp }}
      </button>
      <b-modal
        v-if="this.showConsent"
        :id="`modal-${this.page.SID}`"
        size="lg"
        centered
        hide-footer
      >
        <div class="col-lg-12">
          <h3>{{ this.$store.state.texts.ConsentTitle }}</h3>
          <div v-html="this.$store.state.texts.ConsentDescription"></div>
        </div>
        <div class="col-lg-12">
          <DoCheckbox
            v-model="page.Questions[0].Value"
            :value="page.Questions[0].Value"
            :id="'extra'"
            :config="page.Questions[0].Config"
            :options="page.Questions[0].Options"
          />
        </div>
        <div class="col-lg-12" style="margin-top: 35px">
          <button
            @click="postData()"
            class="btn btn-primary btn-lg"
            style="float: left"
          >
            {{ this.$store.state.pageData.Stepper.buttonSignUp }}
          </button>
        </div>
      </b-modal>
      <b-modal
        class="modal"
        v-if="this.showModal && checkOpeningHours()"
        :id="`modal-leave`"
        size="lg"
        centered
        hide-footer
      >
        <div class="col-lg-12">
          <h2>{{ this.$store.state.pageData.Leave.header }}</h2>
          {{ this.$store.state.pageData.Leave.phonenumber }}
          <div v-html="this.$store.state.pageData.Leave.description"></div>
          <h2>
            <DoPhoneLink :value="this.$store.state.pageData.Leave" />
          </h2>
        </div>
      </b-modal>
    </nav>
  </div>
</template>
<style>
  h2 a {
    font-weight: bolder !important;
    font-size: 1.75rem !important;
    text-transform: uppercase;
  }
</style>
<script>
  import axios from 'axios';
  import { mapState } from 'vuex';
  import MobilePayRedirect from './MobilePayRedirect.vue';

  export default {
    props: ['hasError', 'page'],
    inject: {
      $validator: '$validator',
    },
    components: {
      MobilePayRedirect,
    },
    data: function () {
      return {
        showModal: true,
        showConsent: false,
        showMobilePayRedirect: true,
        mobilePayUrl: null,
        alreadyShown: false,
        supress: false,
        consentShown: false,
        refresh: false,
        mobilePayRedirectText: '',
        secondsToRedirect: 0,
      };
    },
    computed: {
      ...mapState(['pageData', 'newData']),
      steps() {
        return this.newData;
      },
      isFormInvalid() {
        return Object.keys(this.fields).some((key) => this.fields[key].invalid);
      },
      getStep() {
        let currentStep = 0;

        this.newData.map((step, index) => {
          if (step.Slug === this.$route.params.step) {
            currentStep = index;
          }
        });
        return currentStep;
      },
      isUsingMobilePay: function () {
        return this.$store.state.paymentType === 'mobilepay';
      },
    },
    methods: {
      scrollToError() {
        var element = document.querySelector(
          "input[name='" +
            Object.keys(this.fields).filter(
              (key) => this.fields[key].invalid
            )[0] +
            "']"
        );
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      },
      paymentOptionMet() {
        if (this.isUsingMobilePay) {
          return true;
        } else {
          return this.$store.state.regSet && this.$store.state.accountSet;
        }
      },
      startCounter: function () {
        this.intervalId = setInterval(this.doCountdown, 1000);
      },
      doCounter: function () {
        this.secondsToRedirect += 1;
        if (this.secondsToRedirect > 2) {
          this.stopCounter();
        }
      },
      stopCounter: function () {
        window.clearInterval(this.intervalId);
      },
      postData() {
        this.stop();
        this.$validator.validate().then((valid) => {
          if (!valid || !this.paymentOptionMet()) {
            this.$store.state.componentIsInvalid = true;
            return;
          }
          this.$store.state.componentIsInvalid = false;
          sessionStorage.setItem('pageData', JSON.stringify(this.newData));
          let routerPushUrl = this.setRouterPushUrl();
          this.postCreateMemberToCBrain(routerPushUrl);
          if (this.isUsingMobilePay) {
            //Only show modal when post has happened and we do redirect to mobilepay
            this.startCounter();
            this.mobilePayRedirectText =
              this.$store.state.pageData.MobilePayRedirectModal.countdownText;
            this.$bvModal.show('mobilepay-redirect-modal');
            this.supress = true;
            return;
          } else {
            if (this.steps[this.getStep + 1].Slug == 'success') {
              this.$store.state.spinner = true;
            }
            this.$router.push(routerPushUrl);
          }
        });
      },
      isNullOrWhitespace(input) {
        return !input || !input.trim();
      },
      postCreateMemberToCBrain(routerPushUrl) {
        this.$store.state.componentIsInvalid = false;
        this.showConsent = false;
        const endpoint = '/data/CreateMember';
        const data = this.$store.state.newData;
        const step = this.$store.state.pageData;

        axios
          .post(endpoint, { data, step })
          .then((response) => {
            this.$store.state.spinner = false;
            // we dont care about if it is a success or not,
            // we always show the success page (if failed, backupsystem will store the data)
            const success = response.data.d;
            const createdResponse = JSON.parse(success);
            if (this.isUsingMobilePay) {
              if (
                !this.isNullOrWhitespace(
                  createdResponse.MobilePayAgreementAcceptUrl
                )
              ) {
                this.redirectToMobilePay(
                  createdResponse.MobilePayAgreementAcceptUrl
                );
              } else {
                this.mobilePayRedirectText =
                  this.$store.state.pageData.MobilePayRedirectModal.mobilePayErrorText;
                setTimeout(() => {
                  this.$router.push(routerPushUrl);
                }, 5000);
              }
            }
            sessionStorage.clear();
            this.alreadyShown = true;
            this.supress = true;
          })
          .catch(() => {
            sessionStorage.clear();
            this.$router.push(routerPushUrl);
            this.alreadyShown = true;
            this.supress = true;
          });
      },
      redirectToMobilePay: function (mobilePayUrl) {
        window.onbeforeunload = null;
        setTimeout(() => {
          window.location.href = mobilePayUrl;
        }, 2000 - this.secondsToRedirect * 1000);
      },
      setRouterPushUrl() {
        return (
          this.$route.params.pathMatch +
          '/step/success' +
          '/' +
          this.$store.state.employment +
          '/'
        );
      },
      checkOpeningHours() {
        if (this.$store.state.pageData.Leave.Disable === 'true') {
          return false;
        } else {
          var today = new Date();
          var hour = today.getHours();
          var day = today.getDay();
          return day < 5 && hour >= 9 && hour < 16;
        }
      },
      openModal() {
        this.stop();
        this.$validator.validate().then((valid) => {
          if (valid && this.paymentOptionMet()) {
            this.$store.state.componentIsInvalid = false;
            if (!this.consentShown) {
              this.showConsent = true;
              this.consentShown = true;
            } else {
              this.postData();
              this.showConsent = false;
            }
          } else {
            this.$store.state.componentIsInvalid = true;
          }
        });
      },
      goNext() {
        this.$validator.validate();
        this.reset();
        this.start();
        sessionStorage.setItem('pageData', JSON.stringify(this.newData));
        this.$validator.validate().then((valid) => {
          if (valid) {
            this.$store.state.componentIsInvalid = false;
            this.$router.push(
              this.$route.params.pathMatch +
                '/step/' +
                this.steps[this.getStep + 1].Slug +
                '/'
            );
          } else {
            this.$store.state.componentIsInvalid = true;
            this.scrollToError();
          }
        });
      },
      goBack() {
        this.reset();
        this.start();
        this.$router.push(
          this.$route.params.pathMatch +
            '/step/' +
            this.steps[this.getStep - 1].Slug +
            '/'
        );
      },
      start() {
        this.isRunning = true;
        if (!this.timer && !this.alreadyShown) {
          this.timer = setInterval(() => {
            if (this.time > 0) {
              if (this.time === 1) {
                this.$bvModal.show('modal-leave');
                this.alreadyShown = true;
              }
              this.time--;
            } else {
              clearInterval(this.timer);
              this.reset();
            }
          }, 1000);
        }
      },
      stop() {
        clearInterval(this.timer);
      },
      reset() {
        this.isRunning = false;
        clearInterval(this.timer);
        this.timer = null;
        this.time = 1 * 60 + 0;
      },
      setTime(payload) {
        this.time = payload;
      },
    },
    created: function () {
      this.reset();
      this.start();
      window.addEventListener('beforeunload', (event) => {
        // Supress if data is posted (no popup)
        // But this will be shown even though the popup is already shown by other means (eg. leaving the broswer)
        if (
          !this.supress &&
          event.target.activeElement.href != 'tel:33959700'
        ) {
          this.$bvModal.show('modal-leave');
          event.preventDefault();
          event.returnValue = '';
          this.alreadyShown = true;
        }
      }),
        window.addEventListener('mouseout', (e) => {
          if (e.toElement === null && e.fromElement.id === 'detectLeave') {
            if (!this.alreadyShown) {
              this.$bvModal.show('modal-leave');
              e.preventDefault();
              event.returnValue = '';
              this.alreadyShown = true;
            }
          }
        }),
        window.addEventListener('keydown', () => {
          if (!this.alreadyShown) {
            this.reset();
            this.start();
          }
        });
    },
    mounted: function () {
      // Refresh always goes to start!
      if (!this.$route.path.includes('/step/start/')) {
        this.$router.push(
          this.$route.params.pathMatch +
            '/step/' +
            this.steps[0].Slug +
            '/' +
            this.$store.state.employmentTitle
        );
      }
    },
  };
</script>
<style lang="scss" scoped>
  .page-nav {
    position: absolute;
    bottom: -52px;
    left: 0;
    display: flex;
    width: 100%;
  }
  .btn {
    height: 52px;
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    &-white {
      background-color: #fff;
      &:hover {
        background: darken(#fff, 2);
      }
    }
    @include media-breakpoint-down(xs) {
      width: 50%;
    }
  }
</style>

